import { isClientFetchError } from '@atlassian/jira-fetch/src/utils/is-error.tsx';
import { fireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type {
	LoadCardCreateConfigFailureAction,
	LoadCardCreateConfigSuccessAction,
} from '../../../actions/app';
import type { State } from '../../../reducers/types';

export const cardCreateConfigLoadFailure =
	() => (preState: State, state: State, action: LoadCardCreateConfigFailureAction) => {
		const {
			payload: { error },
			meta: { analyticsEvent },
		} = action;
		if (analyticsEvent) {
			fireOperationalAnalytics(analyticsEvent, 'cardCreateConfigLoad failed', {
				isClientFetchError: isClientFetchError(error),
				errorMessage: error?.message,
				statusCode: error?.statusCode,
			});
		}
		return null;
	};

export const cardCreateConfigLoadSuccess =
	() => (preState: State, state: State, action: LoadCardCreateConfigSuccessAction) => {
		const {
			meta: { analyticsEvent },
		} = action;
		if (analyticsEvent) {
			fireOperationalAnalytics(analyticsEvent, 'cardCreateConfigLoad success');
		}
		return null;
	};
